<template>
  <div style="height: 100%; width: 100%">
    <a-row style="display: flex;height: calc(100% - 70px); width: 100%;flex-direction: column;">
      <a-col :span="6" class="hgao">
        <a-row style="text-align: center">
          <a-col :span="8" class="topbg">
            <h1 class="shuliang">
              {{ jzxq.onlineDays }}<span style="font-size: 14px; padding-left: 10px;font-weight: bold;">天</span>
            </h1>
            <h2 style="color: #dfe4ec; font-size: 16px; padding-bottom: 65px">
              在线天数
            </h2>
          </a-col>
          <a-col :span="8" class="topbg">
            <h1 class="shuliang">
              {{ jzxq.today_peak_shaving_total }}<span
                style="font-size: 14px; padding-left: 10px;font-weight: bold;">KWh</span>
            </h1>
            <h2 style="color: #dfe4ec; font-size: 16px; padding-bottom: 65px">
              日总调峰度数
            </h2>
          </a-col>
          <a-col :span="8" class="topbg">
            <h1 class="shuliang">
              {{ jzxq.month_peak_shaving_total }}<span
                style="font-size: 14px; padding-left: 10px;font-weight: bold;">KWh</span>
            </h1>
            <h2 style="color: #dfe4ec; font-size: 16px; padding-bottom: 65px">
              月总调峰度数
            </h2>
          </a-col>
          <!-- <a-col :span="6" class="topbg">
            <h1 class="shuliang">
              95<span style="font-size: 14px; padding-left: 10px">%</span>
            </h1>
            <h2 style="color: #fff; font-size: 16px; padding-bottom: 50px">
              系统寿命预估
            </h2>
          </a-col> -->
        </a-row>
      </a-col>
      <a-col :span="1" class="hgao"> </a-col>
      <a-col :span="8" class="hgao">
        <div class="cfdian">
          <div style="display: flex; padding-top: 15px">

            <h1 style="color: #fff; font-size: 14px; " class="zwbg">
              近12个月充放电量
            </h1>
          </div>
          <div class="hoptions">
            <v-chart class="chart" :option="options" :autoresize="true" />
          </div>
        </div>
      </a-col>
      <a-col :span="1" class="hgao"> </a-col>
      <a-col :span="8" class="hgao">
        <div class="cfdian2">
          <div style="display: flex; padding-top: 15px">

            <h1 style="color: #fff; font-size: 14px; " class="zwbg">
              Pack组网图
            </h1>
          </div>
          <div class="hoptions">
            <ZuWang />
          </div>
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { defineComponent, ref, onMounted, watch } from "vue";
import * as echarts from 'echarts';

import ZuWang from "./ZuWang.vue";
export default defineComponent({
  components: {

    ZuWang,
  },
  props: { jzxq: Object, chatdatacf: Object },
  setup(props) {

    const options = ref({
      tooltip: {
        trigger: 'axis',
      },
      grid: {
        left: '3%',
        right: '3%',
        bottom: '0%',
        top: '6%',
        containLabel: true
      },
      // legend: {
      //     data: ['充电', '放电'],
      //     right: '7%',
      //     top:'-5%',
      //     textStyle: {
      //         color: "#666666"
      //     },
      //     itemWidth: 15,
      //     itemHeight: 10,
      //     itemGap: 25
      // },
      xAxis: {
        type: 'category',
        data: [],
        axisLabel: {
          color: '#A0A4AA'
        },
        axisLine: {
          show: true,
          lineStyle: {
            color: 'rgba(65, 97, 128, 0.5)',
          },
        },
        axisTick: {
          alignWithLabel: true
        }
      },
      yAxis: [{
        type: 'value',
        splitLine: {
          show: true,
          lineStyle: {
            color: 'rgba(163, 163, 163, 0.5)',
            type: 'dashed'
          }
        },
        axisLabel: {
          color: '#A0A4AA'
        },
        axisLine: {
          show: true,
          lineStyle: {
            color: 'rgba(65, 97, 128, 0.5)',
          },
        },
      },
      {
        type: "value",
        name: "",
        nameTextStyle: {
          color: "#666666"
        },
        position: "right",
        axisLine: {
          lineStyle: {
            color: '#cdd5e2'
          }
        },
        splitLine: {
          show: false,
        },
        axisLabel: {
          show: false,
          formatter: "{value} %", //右侧Y轴文字显示
          textStyle: {
            color: "#666666"
          }
        }
      }
      ],
      series: [{
        name: '充电',
        type: 'bar',
        barWidth: '12px',
        itemStyle: {
          normal: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
              offset: 0,
              color: '#12BDDF'
            }, {
              offset: 1,
              color: 'rgba(24, 253, 255, 0)'
            }]),
          },
        },
        data: []
      },
      {
        name: '放电',
        type: 'bar',
        barWidth: '12px',
        itemStyle: {
          normal: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
              offset: 0,
              color: '#DE9600'
            }, {
              offset: 1,
              color: 'rgba(255, 183, 24,0)'
            }]),
          }
        },
        data: []
      }
      ]
    });

    watch(props, () => {
      props.jzxq
      props.chatdatacf.some((item) => {
        options.value.series[0].data.push(item.chargeTotal)
        options.value.series[1].data.push(item.dischargeTotal)
        options.value.xAxis.data.push(item.currentMonth + '月')

      })
    }, {
      deep: true
    });

    onMounted(() => {
      //组件挂载时的生命周期执行的方法
    });

    return {
      options
    };
  },
});
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.cfdian {
  background: url("@/assets/zuwang.png");
  background-size: 100% 100%;
  width: 94%;
  margin: 0 auto;
  height: 100%;
  padding-bottom: 30px;
}

.zwbg {
  background: url("@/assets/biaoti.png") no-repeat;
  width: 288px;
  margin-left: 50px;
  margin-top: 15px;
  margin-bottom: 5px;
  padding-left: 30px;
  font-weight: bold;
}

.cfdian2 {
  background: url("@/assets/zuwang.png");
  background-size: 100% 100%;
  width: 94%;
  margin: 0 auto;
  overflow: hidden;
  padding-bottom: 10px;
}

.topbg {
  background: url("@/assets/gkbg2.png") no-repeat bottom center;
}

.hgao {
  /* height: calc(100% - 53px); */
  width: 100%;
}

.shuliang {
  color: #2489ff;
  font-size: 40px;
  font-family: Arial, Helvetica, sans-serif;
  font-weight: bold;
  height: 30px;
}

.hoptions {
  height: calc(100% - 53px);
}

.ant-col-8 {
  max-width: 100%;
}

.ant-col-6 {
  max-width: 100%;
}
</style>
